import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiEndpoint } from "../utils/constants";
import { enqueueSnackbar } from "notistack";
import { apiFetch } from "@core/index";
import { PartnerChannelsPayload } from "../utils/types";

export const UseCreateNewPartnerChannel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: { payload: PartnerChannelsPayload }) => {
      const response = await apiFetch<{
        statusCode: number;
        message: string;
        data?: unknown;
      }>(`${apiEndpoint}`, {
        method: "POST",
        body: config.payload,
      });
      return response;
    },
    onSuccess: (response) => {
      if (response.statusCode >= 400) {
        enqueueSnackbar(response.message || "", {
          variant: "error",
          autoHideDuration: 5000,
        });
      } else {
        enqueueSnackbar("Partner channel created successfully.", {
          variant: "success",
          autoHideDuration: 2000,
        });
        queryClient.invalidateQueries({ queryKey: ["partnerChannels"] });
      }
    },
    onError: (error: Error) => {
      enqueueSnackbar(
        "Failed to create a new partner channel. Error: " +
          (error.message ?? ""),
        {
          variant: "error",
          autoHideDuration: 5000,
          preventDuplicate: true,
        },
      );
    },
  });
};
